import { useCallback, useEffect, useState } from 'preact/hooks';

import { useCustomerLoyalty } from '@/context/LoyaltyContext';
import { useLoyaltyProgramContext } from '@/context/LoyaltyProgramContext';
import { usePlatformHandlers } from '@/context/PlatformContext';
import { E_CustomerLoyaltyError } from '@/types/RegisteredCustomer';

export function useFetchCustomerLoyalty({ autoFetch = true } = {}) {
  const { setCustomerLoyalty } = useCustomerLoyalty();
  const { fetchCustomerLoyalty } = usePlatformHandlers();
  const { setLoyaltyCardStatus } = useLoyaltyProgramContext();

  const [loading, setLoading] = useState(false);
  const [notFound, setNotFound] = useState(false);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const data = fetchCustomerLoyalty && (await fetchCustomerLoyalty());

      if (data?.basicInfo?.enableId) {
        setCustomerLoyalty(data);
        setLoyaltyCardStatus(data?.basicInfo?.loyaltyCardStatus);
      }
    } catch (err) {
      if (err instanceof Error && err.message === E_CustomerLoyaltyError.NOT_FOUND) {
        setNotFound(true);
      }
    } finally {
      setLoading(false);
    }
  }, [fetchCustomerLoyalty, setCustomerLoyalty, setLoyaltyCardStatus]);

  useEffect(() => {
    if (autoFetch) void fetchData();
  }, [autoFetch, fetchData]);

  return { loading, notFound, refetch: fetchData };
}
